import { useAlertas, type Alerta } from '@/store/useAlertas';
import { useTranslation } from 'react-i18next';

import styles from './AlertHost.module.css';

/**
 * Pilha de alarmes no canto superior direito. Mora no Layout, então vale para
 * o sistema inteiro — a falha aparece esteja o operador em que tela estiver.
 */

const ICONE: Record<Alerta['nivel'], string> = {
  erro: '',
  aviso: '!',
  ok: '',
};

function tempoRelativo(em: number): string {
  const s = Math.round((Date.now() - em) / 1000);
  if (s < 60) return 'agora';
  const m = Math.round(s / 60);
  return m < 60 ? `há ${m} min` : `há ${Math.round(m / 60)}h`;
}

export function AlertHost() {
  const { t } = useTranslation(['common', 'nav', 'board', 'articles', 'analytics', 'feeddrive', 'config', 'strategist']);
  const alertas = useAlertas((s) => s.alertas);
  const fechar = useAlertas((s) => s.fechar);
  if (alertas.length === 0) return null;
  return (
    <div className={styles.host} role="status" aria-live="polite">
      {alertas.map((a) => (
        <div key={a.id} className={`${styles.card} ${styles[a.nivel]}`}>
          <span className={styles.icone}>{ICONE[a.nivel]}</span>
          <div className={styles.corpo}>
            <div className={styles.titulo}>
              {a.titulo}
              {a.repeticoes > 1 && (
                <span className={styles.contador} title="repetições da mesma falha">
                  ×{a.repeticoes}
                </span>
              )}
            </div>
            {a.detalhe && <div className={styles.detalhe}>{a.detalhe}</div>}
            {a.repeticoes > 1 && (
              <div className={styles.quando}>última {tempoRelativo(a.em)}</div>
            )}
          </div>
          <button
            className={styles.fechar}
            onClick={() => fechar(a.id)}
            aria-label={t('common:actions.closeAlert', 'Fechar alerta')}
          >
            
          </button>
        </div>
      ))}
    </div>
  );
}

export default AlertHost;
